"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useMemo, useState } from "react";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import type { ApiWave } from "@/generated/models/ApiWave";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import WaveDropsAll from "../drops/wave-drops-all";
import { CreateDropWaveWrapper, CreateDropWaveWrapperContext } from "../CreateDropWaveWrapper";
import type { ActiveDropState } from "@/types/dropInteractionTypes";
import { ActiveDropAction } from "@/types/dropInteractionTypes";
import PrivilegedDropCreator from "../PrivilegedDropCreator";
import { useAndroidKeyboard } from "@/hooks/useAndroidKeyboard";
import { DropMode } from "../dropComposer.types";
import { WaveDropLayerProvider } from "../drops/WaveDropLayerContext";
interface SingleWaveDropChatProps {
  readonly wave: ApiWave;
  readonly drop: ApiDrop;
  readonly winningThreshold?: number | null | undefined;
  readonly isVotingClosed?: boolean | undefined;
  readonly isVotingControlsLocked?: boolean | undefined;
}
export const SingleWaveDropChat: React.FC<SingleWaveDropChatProps> = t0 => {
  const $ = _c(33);
  const {
    wave,
    drop,
    winningThreshold: t1,
    isVotingClosed: t2,
    isVotingControlsLocked: t3
  } = t0;
  const winningThreshold = t1 === undefined ? null : t1;
  const isVotingClosed = t2 === undefined ? false : t2;
  const isVotingControlsLocked = t3 === undefined ? false : t3;
  const {
    isApp
  } = useDeviceInfo();
  const {
    isVisible: isKeyboardVisible
  } = useAndroidKeyboard();
  const t4 = isKeyboardVisible ? "0px" : "calc(env(safe-area-inset-bottom))";
  let t5;
  if ($[0] !== t4) {
    t5 = {
      paddingBottom: t4
    };
    $[0] = t4;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const inputContainerStyle = t5;
  let t6;
  if ($[2] !== drop) {
    t6 = {
      action: ActiveDropAction.REPLY,
      drop,
      partId: 1
    };
    $[2] = drop;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const [activeDrop, setActiveDrop] = useState(t6);
  const isVotingActionLocked = isVotingClosed || isVotingControlsLocked;
  const fixedDropMode = isVotingActionLocked ? DropMode.CHAT : DropMode.BOTH;
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = t8 => {
      const {
        targetDrop,
        partId,
        action
      } = t8;
      setActiveDrop({
        action,
        drop: targetDrop,
        partId
      });
    };
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  const handleDropAction = t7;
  let t8;
  if ($[5] !== drop) {
    t8 = () => {
      setActiveDrop({
        action: ActiveDropAction.REPLY,
        drop,
        partId: 1
      });
    };
    $[5] = drop;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  const resetActiveDrop = t8;
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      mobileMenuZIndexClassName: "tw-z-[1020]",
      mobileDialogZIndexClassName: "tw-z-[1030]"
    };
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = t11 => {
      const {
        drop: repliedDrop,
        partId: partId_0
      } = t11;
      return handleDropAction({
        targetDrop: repliedDrop,
        partId: partId_0,
        action: ActiveDropAction.REPLY
      });
    };
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  let t11;
  if ($[9] !== activeDrop || $[10] !== drop.id || $[11] !== isVotingClosed || $[12] !== isVotingControlsLocked || $[13] !== wave.id || $[14] !== wave.metrics.muted || $[15] !== wave.metrics.your_unread_drops_count || $[16] !== winningThreshold) {
    t11 = <div className="tw-min-h-0 tw-flex-1"><WaveDropsAll waveId={wave.id} onReply={t10} activeDrop={activeDrop} initialDrop={null} unreadCount={wave.metrics.your_unread_drops_count} dropId={drop.id} isMuted={wave.metrics.muted} winningThreshold={winningThreshold} isVotingClosed={isVotingClosed} isVotingControlsLocked={isVotingControlsLocked} /></div>;
    $[9] = activeDrop;
    $[10] = drop.id;
    $[11] = isVotingClosed;
    $[12] = isVotingControlsLocked;
    $[13] = wave.id;
    $[14] = wave.metrics.muted;
    $[15] = wave.metrics.your_unread_drops_count;
    $[16] = winningThreshold;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== inputContainerStyle || $[19] !== isApp) {
    t12 = isApp ? inputContainerStyle : {
      paddingBottom: "calc(env(safe-area-inset-bottom))"
    };
    $[18] = inputContainerStyle;
    $[19] = isApp;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== activeDrop || $[22] !== drop.id || $[23] !== fixedDropMode || $[24] !== resetActiveDrop || $[25] !== wave) {
    t13 = <CreateDropWaveWrapper context={CreateDropWaveWrapperContext.SINGLE_DROP}><PrivilegedDropCreator activeDrop={activeDrop} onCancelReplyQuote={resetActiveDrop} onDropAddedToQueue={resetActiveDrop} wave={wave} dropId={drop.id} fixedDropMode={fixedDropMode} /></CreateDropWaveWrapper>;
    $[21] = activeDrop;
    $[22] = drop.id;
    $[23] = fixedDropMode;
    $[24] = resetActiveDrop;
    $[25] = wave;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t12 || $[28] !== t13) {
    t14 = <div style={t12} className="tw-mt-auto">{t13}</div>;
    $[27] = t12;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t11 || $[31] !== t14) {
    t15 = <WaveDropLayerProvider value={t9}><div className="tw-flex tw-h-full tw-min-h-0 tw-flex-1 tw-flex-col"><div className="tw-relative tw-flex tw-min-h-0 tw-flex-1 tw-flex-col tw-overflow-hidden tw-border-y-0 tw-border-l-0 tw-border-iron-800 tw-bg-iron-950 lg:tw-border lg:tw-border-r lg:tw-border-solid"><div className="tw-relative tw-flex tw-min-h-0 tw-flex-1 tw-flex-col"><div className="tw-flex tw-min-h-0 tw-w-full tw-flex-1 tw-flex-col"><div className="tw-flex tw-min-h-0 tw-w-full tw-flex-1 tw-flex-col">{t11}{t14}</div></div></div></div></div></WaveDropLayerProvider>;
    $[30] = t11;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  return t15;
};